<template>
  <div class="md-layout title">
    <div class="md-layout-item">
      <span class="title-display">
        <span class="error">error</span>
        <span class="dot">.</span>
        <span class="guru">guru</span>
      </span>
      <span class="minititle-display">Your personal Windows error code lookup guru</span>
    </div>
  </div>
</template>

<script scoped>
export default {
  name: "Title",
  props: {
    msg: String
  }
};
</script>

<style lang="scss" scoped>
.title {
  z-index: 1;
  padding-bottom: 100px;
  text-align: center;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}

.title-display {
  letter-spacing: -4px;
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.158);
  font-size: 110px;
}

.minititle-display {
  padding-top: 30px;
  font-size: 20px;
  display: block;
  margin: 0 20px 0 20px;
}

@media (max-width: 500px) {
  .title {
    padding-bottom: 40px;
  }
  .title-display {
    font-size: 70px;
    font-size: 20vw;
  }
  .minititle-display {
    font-size: 16px;
  }
}

.error {
  color: rgb(59, 97, 131);
}

.dot {
  color: rgb(7, 152, 172);
}

.guru {
  color: rgb(255, 255, 255);
}
</style>